<!-- 统一用户权限管理 - 组织机构管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部组织机构</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="orgQueryForm" :model="orgQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="5" :offset="4">
                                    <el-form-item prop="orgName">
                                        <el-input v-model="orgQueryForm.orgName" :maxlength="100" placeholder="组织机构名称"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="orgCode">
                                        <el-input v-model="orgQueryForm.orgCode" :maxlength="100" placeholder="组织机构代码"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item class="el-align-center">
                                        <el-button @click="resetOrgQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button type="primary" @click="queryOrgList(1000)" icon="fas fa-search">查 询</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button type="primary" size="small" icon="fas fa-plus-circle" @click="openOrgEditDialog('add')">添加组织机构</el-button>
                    </div>
                    <div class="el-search-list">
                        <el-table ref="orgTable" v-loading="orgQueryLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: orgQueryLoading}" :data="orgList" :default-sort="orgQuerySort" @sort-change="onOrgQuerySortChange" style="width:100%;" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                            <el-table-column label="#" type="index" width="40"></el-table-column>
                            <el-table-column label="组织机构名称" prop="orgName" width="300" sortable></el-table-column>
                            <el-table-column label="组织机构代码" prop="orgCode" width="150" sortable></el-table-column>
                            <el-table-column label="组织机构描述" prop="orgDesc"></el-table-column>
                            <el-table-column label="创建时间" prop="createTime" width="100" align="center" sortable></el-table-column>
                            <el-table-column label="操作" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openOrgViewDialog('view', scope.row)">查看详情</el-button>
                                    <el-dropdown size="small" trigger="click" @command="handleOrgCommand(arguments[0], scope.row)">
                                        <span class="el-dropdown-link">
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view">查看详情</el-dropdown-item>
                                            <el-dropdown-item command="edit">修改组织机构</el-dropdown-item>
                                            <el-dropdown-item command="delete" divided>删除组织机构</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination background v-show="showOrgQueryPager" @current-change="onOrgQueryCurrentPageChange" :current-page.sync="orgQueryForm.currentPage" :page-size="orgQueryForm.pageSize" layout="slot, prev, pager, next, total" :total="orgQueryTotal">
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button :class="{active: orgQueryForm.pageSize == 10}" @click="onOrgQueryPageSizeChange(10);">10</el-button>
                                    <el-button :class="{active: orgQueryForm.pageSize == 20}" @click="onOrgQueryPageSizeChange(20);">20</el-button>
                                    <el-button :class="{active: orgQueryForm.pageSize == 50}" @click="onOrgQueryPageSizeChange(50);">50</el-button>
                                    <el-button :class="{active: orgQueryForm.pageSize == 100}" @click="onOrgQueryPageSizeChange(100);">100</el-button>
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer size="70%" :visible.sync="orgEditDialogVisible" @closed="closeOrgEditDialog">
                        <span slot="title" class="el-drawer-title"> {{orgEditDialogTitle}}</span>
                        <div class="el-drawer-content">
                            <el-form class="el-drawer-content-body" ref="orgEditForm" :model="orgEditForm" :rules="orgEditRules" label-width="120px">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="组织机构名称" prop="orgName">
                                            <el-col :span="16">
                                                <el-input v-model="orgEditForm.orgName" :maxlength="50"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">4~50个汉字、字母、数字及下划线组成.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="组织机构代码" prop="orgCode">
                                            <el-col :span="16">
                                                <el-input v-model="orgEditForm.orgCode" :maxlength="50"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">2~50个字母、数字、下划线组成.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="所在地区" prop="areaCode">
                                            <el-col :span="16">
                                                <el-select class="el-full-width" v-model='orgEditForm.areaCode' placeholder=' '>
                                                    <el-option v-for='(item, index) in allAreaList' :key='index'
                                                            :label='item.areaName' :value='item.areaCode'></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="组织机构描述" prop="orgDesc">
                                            <el-col :span="16">
                                                <el-input type="textarea" v-model="orgEditForm.orgDesc" :maxlength="512"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeOrgEditDialog">取 消</el-button>
                                <el-button type="primary" icon="far fa-save" @click="saveOrg" :loading="submiting">确 定</el-button>
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer size="70%" :visible.sync="orgViewDialogVisible" @closed="closeOrgViewDialog">
                        <span slot="title" class="el-drawer-title"> 查看组织机构详情</span>
                        <div class="el-drawer-content">
                            <div class="el-drawer-content-body">
                                <el-form class="el-form-detail" inline label-position="right" label-width="120px" label-suffix="：">
                                    <el-form-item label="组织机构ID">{{orgViewForm.orgId}}</el-form-item>
                                    <el-form-item label="组织机构代码">{{orgViewForm.orgCode}}</el-form-item>
                                    <el-form-item label="所在地区">{{orgViewForm.areaName}}</el-form-item>

                                    <el-form-item label="组织机构名称" style="width:100%;">{{orgViewForm.orgName}}</el-form-item>

                                    <el-form-item label="组织机构描述" style="width:100%;">{{orgViewForm.orgDesc}}</el-form-item>

                                    <el-form-item label="创建时间">{{orgViewForm.createTime}}</el-form-item>
                                    <el-form-item label="修改时间">{{orgViewForm.updateTime}}</el-form-item>
                                </el-form>
                            </div>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeOrgViewDialog">关 闭</el-button>
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

export default {
    name: 'UpmsOrganization',
    data() {
        return {
            allAreaList: [],
            submiting: false,
            orgList: [],
            orgQueryLoading: false,
            orgQuering: false,
            orgQueryForm: {
                orgName: '',
                orgCode: '',
                pageSize: 10,
                currentPage: 1
            },
            orgQueryTotal: 0,
            orgQuerySort: {
                prop: 'createTime',
                order: 'descending'
            },
            currentActionType: 'add',
            orgEditDialogVisible: false,
            orgViewDialogVisible: false,
            orgEditForm: {
                orgId: '',
                orgName: '',
                orgCode: '',
                orgDesc: '',
                areaCode: null,
            },
            orgEditRules: {
                orgName: [
                    {
                        required: true,
                        message: '请输入组织机构名称!'
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{4,50}$/,
                        message:
                            '组织机构名称由4~50个汉字、字母、数字及下划线组成!'
                    }
                ],
                orgCode: [
                    {
                        required: true,
                        message: '请输入组织机构代码!'
                    },
                    {
                        pattern: /^\w{2,50}$/,
                        message: '组织机构代码由2~50个字母、数字、下划线组成!'
                    }
                ]
            },
            orgViewForm: {
                orgId: '',
                orgName: '',
                orgCode: '',
                orgDesc: '',
                areaName: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: ''
            }
        };
    },
    computed: {
        showOrgQueryPager() {
            if (this.orgQuering || this.orgQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        orgEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加组织机构';
            } else if (this.currentActionType == 'edit') {
                return '修改组织机构';
            } else {
                return '';
            }
        }
    },
    created() {},
    mounted() {
        this.loadAllAreaList();
        this.queryOrgList(1000);
    },
    methods: {
        getOrgTypeTagType(orgType) {
            if (orgType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        loadAllAreaList() {
            let url = PLATFORM_API.of('/api/platform/upms/baseArea/all');
            this.$http.get(url).then(response => {
                let result = response.data;
                if (result.success) {
                    this.allAreaList = result.data;
                }
            }).catch(defaultApiErrorHandler);
        },
        queryOrgList(loading) {
            this.orgQueryForm.currentPage = 1;
            this.doQueryOrgList(loading);
        },
        doQueryOrgList(loading) {
            this.orgQuering = true;
            if (loading) {
                this.orgQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.orgQueryForm,
                    mapSort(this.orgQuerySort)
                );
                this.$http
                    .get(PLATFORM_API.of('/api/platform/upms/org/list'), {
                        params: params
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.orgList = result.data;
                            this.orgQueryTotal = result.totalRowCount;
                        } else {
                            this.orgList = [];
                            this.orgQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.orgList = [];
                        this.orgQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.orgQueryLoading = false;
                        }
                        this.orgQuering = false;
                    });
            }, loading);
        },
        resetOrgQueryForm() {
            this.$refs.orgQueryForm.resetFields();
        },
        onOrgQuerySortChange(parameter) {
            if (
                this.orgQuerySort.prop != parameter.prop ||
                this.orgQuerySort.order != parameter.order
            ) {
                this.orgQuerySort.prop = parameter.prop;
                this.orgQuerySort.order = parameter.order;
                this.queryOrgList(1000);
            }
        },
        onOrgQueryPageSizeChange(pageSize) {
            this.orgQueryForm.pageSize = pageSize;
            this.queryOrgList(1000);
        },
        onOrgQueryCurrentPageChange(currentPage) {
            this.orgQueryForm.currentPage = currentPage;
            this.doQueryOrgList(1000);
        },
        handleOrgCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openOrgEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openOrgViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteOrg(row);
            }
        },
        openOrgEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.orgEditDialogVisible = true;
            if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.orgEditForm).forEach(name => {
                        let value = row[name];
                        this.orgEditForm[name] = value;
                    });
                });
            }
        },
        closeOrgEditDialog() {
            this.submiting = false;
            this.orgEditDialogVisible = false;
            this.$refs.orgEditForm.resetFields();
            //手动reset
            this.orgEditForm.orgId = '';
        },
        openOrgViewDialog(cmd, row) {
            this.currentActionType = cmd;
            this.orgViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.orgViewForm).forEach(name => {
                    let value = row[name];
                    this.orgViewForm[name] = value;
                });
            });
        },
        closeOrgViewDialog() {
            this.orgViewDialogVisible = false;
            Object.keys(this.orgViewForm).forEach(name => {
                this.orgViewForm[name] = '';
            });
        },
        deleteOrg(row) {
            let url = PLATFORM_API.of(
                '/api/platform/upms/org/delete/' + row.orgId
            );
            this.$confirm('您确定要删除该组织机构?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .delete(url)
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryOrgList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
        saveOrg() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of('/api/platform/upms/org/create');
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of('/api/platform/upms/org/update');
                method = 'put';
            }
            if (url) {
                this.$refs.orgEditForm.validate(valid => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.orgEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeOrgEditDialog();
                                        this.$message.success(result.message);
                                        this.queryOrgList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        }
    }
};
</script>